import { cn } from "@/utils";
import type { LucideIcon } from "lucide-react";
import { railHeadingLabelClassName } from "./RailGroup";

export function RailHeadingLink({
  icon: Icon,
  label,
  active,
  onClick,
  className,
}: {
  icon: LucideIcon;
  label: string;
  active?: boolean;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex min-h-10 w-full items-center gap-2 rounded-md px-2 text-left outline-none hover:bg-n-05 focus-visible:outline-2 focus-visible:outline-rust focus-visible:outline-offset-[-2px]",
        active && "bg-n-05",
        className,
      )}
    >
      <Icon className="size-3.5 shrink-0 text-n-50" />
      <span
        className={cn(
          railHeadingLabelClassName,
          "text-n-50 hover:text-n-70",
          active && "text-n-90",
        )}
      >
        {label}
      </span>
    </button>
  );
}
